(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ncl-coffret-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.ncl-coffret-menu details[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.ncl-coffret-menu details[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ncl-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ncl-mobile-navigation')) {
    customElements.define('ncl-mobile-navigation',class extends HTMLElement {
      connectedCallback() {
        this.dialog=this.querySelector('dialog');
        this.media=window.matchMedia('(max-width:991px)');
        this.events=new AbortController();
        const signal=this.events.signal;
        this.header=this.closest('.shopify-section')?.querySelector('header');
        this.accountTrigger=this.header?.querySelector('.top-link__title');
        if(this.accountTrigger){this.accountTrigger.setAttribute('role','button');this.accountTrigger.tabIndex=0;this.accountTrigger.setAttribute('aria-label',this.dataset.accountLabel);}
        this.header?.querySelectorAll('.header__icon--search').forEach(el=>el.setAttribute('aria-label',this.dataset.searchLabel));
        this.syncSearchTriggers=()=>{
          this.header?.querySelectorAll('.header__icon--search').forEach(el=>{
            if(this.media.matches){el.removeAttribute('data-bs-toggle');el.setAttribute('aria-expanded','false');}
            else el.setAttribute('data-bs-toggle','collapse');
          });
          if(this.media.matches)this.header?.querySelector('#searchTop')?.classList.remove('show');
        };
        this.syncSearchTriggers();
        this.media.addEventListener('change',this.syncSearchTriggers,{signal});
        this.triggerView=target=>{
          if(!this.media.matches||!this.header?.contains(target))return null;
          if(target.closest('.header__icon--menu'))return 'menu';
          if(target.closest('.header__icon--search'))return 'search';
          if(target.closest('.top-link__title'))return 'account';
          return null;
        };
        document.addEventListener('click',event=>{
          const view=this.triggerView(event.target);
          if(!view)return;
          event.preventDefault();event.stopImmediatePropagation();
          this.opener=event.target.closest('summary,a,button,.top-link__title');
          this.show(view);
        },{capture:true,signal});
        this.accountTrigger?.addEventListener('keydown',event=>{
          if(this.media.matches&&(event.key==='Enter'||event.key===' ')){event.preventDefault();event.stopImmediatePropagation();this.opener=this.accountTrigger;this.show('account');}
        },{signal});
        this.querySelector('[data-nav-close]').addEventListener('click',()=>this.dialog.close(),{signal});
        this.querySelectorAll('[data-nav-view]').forEach(button=>button.addEventListener('click',()=>this.setView(button.dataset.navView),{signal}));
        this.dialog.addEventListener('close',()=>{
          document.body.style.overflow=this.previousOverflow??'';
          this.opener?.setAttribute('aria-expanded','false');
          this.opener?.focus();
        },{signal});
        this.media.addEventListener('change',()=>{if(!this.media.matches&&this.dialog.open)this.dialog.close();},{signal});
        this.dialog.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>this.dialog.close(),{signal}));
      }
      setView(view) {
        this.querySelectorAll('[data-nav-panel]').forEach(panel=>{panel.hidden=panel.dataset.navPanel!==view;});
        this.querySelectorAll('[data-nav-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.navView===view)));
        if(view==='search')this.querySelector('input[type="search"]').focus({preventScroll:true});
      }
      show(view) {
        this.setView(view);
        if(!this.dialog.open){this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();}
        this.opener?.setAttribute('aria-expanded','true');
        if(view==='search')this.querySelector('input[type="search"]').focus({preventScroll:true});
      }
      disconnectedCallback(){if(this.dialog.open)this.dialog.close();this.events?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
